class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><g clip-path="url(#a)"><path d="M11.749 8a3.75 3.75 0 1 1 .003 7.5A3.75 3.75 0 0 1 11.75 8ZM7.5.5a7 7 0 0 1 6.997 6.843l.003.157h-1a6.001 6.001 0 0 0-12 0 6 6 0 0 0 5.846 5.997l.154.003v1c-3.869 0-7-3.134-7-7 0-3.869 3.131-7 7-7ZM11.749 9A2.746 2.746 0 0 0 9 11.749 2.75 2.75 0 1 0 11.749 9Zm.897 1.146.705.705-.897.898.897.897-.705.705-.897-.897-.898.897-.705-.705.897-.897-.897-.898.705-.705.898.897.897-.897ZM8 3v4.5a.488.488 0 0 1-.106.303l-.043.048L5.746 9.96l-.709-.709L7 7.291V3h1Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs></svg>';
  }
}
const t = "pi-mod-lost-time";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
